import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { StepperEventsService } from '../../services/stepper-events.service';

@Component({
    selector: 'cw-stepper-item',
    templateUrl: './stepper-item.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CwStepperItemComponent {
    @Input()
    public title!: string;

    @Input()
    public alias!: string;

    @Input()
    public disabled!: boolean;

    @Input()
    public nextLabel = 'Continue';

    @Input()
    public allowChangeStep = true;

    @Input()
    public stepText!: string;

    @Output()
    public goNext = new EventEmitter<IChangeStepEvent>();

    @ViewChild('number', {static: true})
    public numberElement!: ElementRef;

    public active = false;
    public completed = false;
    public isLast = false;
    public isFirst = false;
    public showLoaderOnNext = false;

    protected _number = 0;

    constructor(
        protected stepperEvents: StepperEventsService
    ) {}

    get number(): number {
        return this._number;
    }

    set number(value: number) {
        this._number = value;
        this.numberElement.nativeElement.innerText = this.stepText || this._number;
    }

    public continue(): void {
        if (this.goNext.observers.length === 0) {
            this.stepperEvents.nextTopic.next(this.alias);
        } else {
            this.showLoaderOnNext = true;
            this.goNext.emit({
                ok: () => {
                    this.showLoaderOnNext = false;
                    this.stepperEvents.nextTopic.next(this.alias);
                },
                reject: () => {
                    this.showLoaderOnNext = false;
                }
            });
        }
    }

    public back(): void {
        this.stepperEvents.prevTopic.next(this.alias);
    }

    public show(): void {
        this.active = true;
    }

    public hide(isCompleted = false): void {
        this.active = false;
        this.completed = isCompleted;
    }

    public goto(): void {
        this.stepperEvents.gotoTopic.next(this.alias);
    }
}

export interface IChangeStepEvent {
    ok: () => void;
    reject: () => void;
}
